import React from "react";
import { useIntl } from "react-intl";
import NoData from "./NoData";

const NoQAData = ({ children, data }) => {
  const intl = useIntl();

  return (
    <NoData
      data={data}
      message={intl.formatMessage({
        id: "Shared.NoQAData.NoQA",
        defaultMessage: "There are no QA. Please check later for new contents..."
      })}
    >
      {children}
    </NoData>
  );
};

export default NoQAData;
